import { render, staticRenderFns } from "./hearing-loss-results.vue?vue&type=template&id=46731d88&"
import script from "./hearing-loss-results.vue?vue&type=script&lang=js&"
export * from "./hearing-loss-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports